var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg41(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "54") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons-day",
    transform: "translate(-2996.000000, -6.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons",
    transform: "translate(25.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 54,
    transform: "translate(2971.000000, 3.400000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6959238,5.99771429 C11.200451,5.99771429 11.6864061,6.0772447 12.141936,6.22445253 L12.265442,6.2677088 C11.1840637,7.64977044 10.4857536,9.34604499 10.3303351,11.1967619 L10.3303351,11.1967619 L9.79793798,11.1967619 C8.48995285,11.1967619 7.27680507,11.6016988 6.27691884,12.2930147 C6.09614724,11.7955199 5.99771429,11.257215 5.99771429,10.6959238 C5.99771429,8.10121265 8.10121265,5.99771429 10.6959238,5.99771429 Z",
    id: "Combined-Shape",
    fill: "#FED100"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FED100",
    x: 0,
    y: 9.89622857,
    width: 4.49828571,
    height: 1.59939048,
    rx: 0.799695238
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FED100",
    transform: "translate(4.723126, 4.723160) rotate(45.000000) translate(-4.723126, -4.723160) ",
    x: 2.473983,
    y: 3.92346459,
    width: 4.49828571,
    height: 1.59939048,
    rx: 0.799695238
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FED100",
    x: 9.89622857,
    y: 0,
    width: 1.59939048,
    height: 4.49828571,
    rx: 0.799695238
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5810097,4.19942857 C22.2141974,4.19942857 24.5964777,5.51858873 26.0155606,7.59897917 C22.3513965,7.68210385 19.3703199,10.5126144 19.0676901,14.1018258 L19.0676901,14.1018258 L18.6583461,14.1018258 C16.0261492,14.1018258 13.8935619,16.2260163 13.8935619,18.8464177 C13.8935619,20.1025155 14.3835606,21.2444081 15.1835645,22.0930484 L9.79793798,22.0926095 C7.20262705,22.0926095 5.09942857,19.989611 5.09942857,17.3944 C5.09942857,14.8714726 7.08731104,12.8134143 9.58282788,12.7010245 L9.79793798,12.6961905 L11.7091096,12.6961905 L11.8245656,11.3222141 C12.1614373,7.31054293 15.5282542,4.19942857 19.5810097,4.19942857 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1792798,9.09653333 C28.5891614,9.09653333 30.7076541,10.6137551 31.4966534,12.8355084 L31.4966534,12.8355084 L31.9125949,14.006862 L33.1408268,13.815235 C33.3560448,13.7816478 33.5751613,13.7646543 33.7970767,13.7646543 C36.1110949,13.7646543 37.984381,15.6300434 37.984381,17.9281676 C37.984381,20.2260919 36.1110949,22.091581 33.7970767,22.091581 L33.7970767,22.091581 L18.6583461,22.091581 C16.8533339,22.091581 15.3929905,20.637635 15.3929905,18.8464177 C15.3929905,17.0553003 16.8530341,15.6012544 18.6583461,15.6012544 L18.6583461,15.6012544 L20.4458648,15.6012544 L20.5618206,14.2277778 C20.8053278,11.3393786 23.242699,9.09653333 26.1792798,9.09653333 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2911238,29.7886476 L23.765181,28.3897807 C24.1232504,28.1880628 24.5769728,28.3122208 24.7824463,28.6681484 C24.9879199,29.024076 24.8685417,29.4790795 24.5147953,29.6882859 L22.0905192,31.0882523 L24.5147953,32.4882188 C24.8672655,32.6979756 24.9857467,33.152039 24.780702,33.5072711 C24.5756574,33.8625032 24.1232119,33.9870202 23.7652809,33.786724 L21.2911238,32.3876571 L21.2911238,35.2365714 C21.2911238,35.6506272 20.9554653,35.9862857 20.5414095,35.9862857 C20.1273538,35.9862857 19.7916952,35.6506272 19.7916952,35.2365714 L19.7916952,32.3876571 L17.4176,33.786724 C17.0595306,33.9884419 16.6058081,33.8642838 16.4003346,33.5083562 C16.1948611,33.1524286 16.3142393,32.6974252 16.6679857,32.4882188 L19.0922618,31.0882523 L16.6679857,29.6882859 C16.3155155,29.4785291 16.1970343,29.0244657 16.4020789,28.6692336 C16.6071236,28.3140015 17.0595691,28.1894845 17.4175,28.3897807 L19.7916952,29.7886476 L19.7916952,27.0396952 C19.7916952,26.6256395 20.1273538,26.289981 20.5414095,26.289981 C20.9554653,26.289981 21.2911238,26.6256395 21.2911238,27.0396952 L21.2911238,29.7886476 Z",
    id: "Path",
    fill: "#FFFFFF"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg41);
export default __webpack_public_path__ + "static/media/41.3d224b817c0cd77e520206aee4f2efe3.svg";
export { ForwardRef as ReactComponent };